<template>
  <div
    class="page-body container mx-auto flex flex-col justify-between items-center font-heiti"
  >
    <div class="flex-1 flex flex-col place-self-end space-y-4 pt-20">
      <div
        class="text-3xl text-blue-level tracking-tighter transform scale-x-80 origin-right"
      >
        吉林市国家级中小企业数字化转型试点城市
      </div>
      <div
        class="w-4/5 place-self-end text-right space-y-3 text-4xl border-t border-b border-solid border-black py-5 font-medium"
      >
        <div class="space-y-10 font-xbs">
          <div class="space-x-1">
            <span>中</span><span>小</span><span>企</span><span>业</span
            ><span>数</span><span>字</span><span>化</span><span>水</span
            ><span>平</span>
          </div>
          <div class="text-7xl space-x-6">
            <span>评</span><span>测</span><span>报</span><span>告</span>
          </div>
        </div>
      </div>
      <div
        class="text-2xl text-blue-level text-right pt-1 font-times tracking-wide"
      >
        SME Digital Level Assessment Report
      </div>
      <div class="text-xl text-blue-level text-right pt-1">
        报告编号：<span class="font-times">{{ info.reportNum }}</span>
      </div>
    </div>
    <div
      class="flex-1 flex flex-col space-y-1 place-self-start justify-center space-y-2 text-xl"
    >
      <div class="flex flex-col space-y-1">
        <span class="border-b border-black border-solid w-32">试点企业</span>
        <span class="flex-1 text-blue-level">{{ info.eName }}</span>
      </div>
      <div class="flex flex-col space-y-1">
        <span class="border-b border-black border-solid w-32">评测机构</span>
        <div class="flex-1 text-blue-level flex flex-col items-start space-y-1">
          <span>吉林吉大通信设计院股份有限公司</span>
          <span>吉林省电子技术研究所</span>
        </div>
      </div>
      <div class="flex flex-col space-y-1">
        <span class="border-b border-black border-solid w-32">委托单位</span>
        <span class="flex-1 text-blue-level">吉林市工业和信息化局</span>
      </div>
      <div class="flex flex-col space-y-1">
        <span class="border-b border-black border-solid w-32">报告日期</span>
        <span class="flex-1 text-blue-level tracking-widest"
          >{{
            (info.reportDate || "2024-01-01")
              .substring(0, 10)
              .replace("-", "年")
              .replace("-", "月")
          }}日</span
        >
      </div>
    </div>
  </div>
</template>

<script>
// 封面
export default {
  props: ["info"],
};
</script>
